import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/api/client'
import { refresh } from '@/api/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/DashboardView.vue')
  },
  {
    path: '/summit',
    name: 'summit',
    component: () => import('../views/SummitListView.vue')
  },
  {
    path: '/tour',
    name: 'tour',
    component: () => import('../views/TourListView.vue')
  },
  {
    path: '/sponsorship',
    name: 'sponsorship',
    component: () => import('../views/SponsorshipListView.vue')
  },
  {
    path: '/attendance',
    name: 'attendance',
    component: () => import('../views/AttendanceView.vue')
  },
  {
    path: '/countdown',
    name: 'countdown',
    component: () => import('../views/CountdownView.vue')
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('../views/LogsView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue')
  },
  {
    path: '/registrations/:id/invoice',
    name: 'invoice',
    component: () => import('../views/InvoiceView.vue'),
    meta: { standalone: true }
  },
  {
    path: '/registrations/:id/receipt',
    name: 'receipt',
    component: () => import('../views/ReceiptView.vue'),
    meta: { standalone: true }
  },
  {
    path: '/dev-invoice',
    name: 'dev-invoice',
    component: () => import('../views/DevInvoiceView.vue'),
    meta: { standalone: true, public: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ─── Navigation guard: redirect to /login if no token ────────────────────────
router.beforeEach(async (to, from, next) => {
  // Public routes don't need auth
  if (to.meta.public) return next()

  // Already have a token in memory → proceed
  if (getToken()) return next()

  // No token in memory — try refreshing from httpOnly cookie
  try {
    const resp = await refresh()
    if (resp.success) return next()
  } catch (e) {
    // refresh failed
  }

  // Not authenticated → go to login
  next({ name: 'login' })
})

export default router
